import { Button, CheckboxInput, Form, TextInput } from "armstrong-react";
import React from "react";
import _ from "underscore";

import { FlowBox } from "../../../core/atoms/atoms";
import { GoogleAnalyticsHelper } from "@travellocal/ui";

interface Props {
  login: (email: string, pass: string) => Promise<any>;
}

interface State {
  email?: string;
  password?: string;
  errorMessage?: string;
  visiblePassword?: boolean;
}

export default class LoginForm extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {};
  }

  private login = async () => {
    const email = this.state.email ? this.state.email.trim() : this.state.email;
    const pass = this.state.password;

    if (!email || email.length < 1) {
      this.setState({ errorMessage: "you haven't entered an email address" });
      return;
    }

    if (!pass || pass.length < 1) {
      this.setState({ errorMessage: "you haven't entered a password" });
      return;
    }

    try {
      await this.props.login(email, pass);
    }
    catch (e) {
      GoogleAnalyticsHelper.logEvent("Login", "Response", "Login failed");
      const err = e as IApiErrorResponse;
      this.setState({ errorMessage: err.message });
    }
  }

  public render() {
    return (
      <Form className="login-form" dataBinder={Form.jsonDataBinder(this.state)} onDataChanged={() => this.forceUpdate()}>
        {this.state.errorMessage &&
          <div className="validation-bar">There was a problem logging in - {this.state.errorMessage}</div>
        }

        <label>Your email address</label>
        <TextInput {...Form.Bind.textEmail("email") } placeholder="e.g. traveller@example.com" />

        <label>Your password</label>
        <TextInput {...(this.state.visiblePassword ? Form.Bind.text("password") : Form.Bind.password("password"))} placeholder="**********" />

        <FlowBox>
          <CheckboxInput {...Form.Bind.checkbox("visiblePassword")} labelContent="Show password" />
          <Button disabled={!this.state.email || this.state.email.length < 1} type="submit" onClick={() => this.login()} leftIcon={Button.Icomoon.lock}>
            Sign in
          </Button>
        </FlowBox>
      </Form>
    );
  }
}
